export default {
  title: 'Apps',
  fields: {
    id: 'ID',
    name: 'Naam',
    app_bundle_identifier: 'App Bundle ID',
    released: 'Uitgebracht',
    franchise: 'Merk',
    app_icon: 'App-icoon',
    status: 'Status',
    play_store_link: 'Play Store-link',
    apple_store_link: 'Apple Store-link',
    dynamic_link: 'Dynamische link - QR-codes',
  },
  filters: {
    name: 'Naam',
    released: 'Uitgebracht',
  },
  columns: {
    backlog: '📋 Backlog',
    ready_to_build: '🛠️ Klaar om te bouwen',
    in_work: '🔧 In uitvoering',
    in_review: '📝 In beoordeling',
    rejected: '❌ Afgewezen',
    released: '✅ Uitgebracht',
    deactivated: '🛑 Gedeactiveerd',
  },
  card: {
    overdue: 'Te laat · {{time}}',
    copied: 'Gekopieerd naar klembord',
    released_tag: {
      both: '✅ Uitgebracht',
      ios: 'iOS uitgebracht',
      android: 'Android uitgebracht',
    },
    tags: {
      has_tech_issue: 'Technisch probleem',
    },
  },
  status_modal: {
    title: 'Releasestatus bijwerken',
    status_label: 'Status',
    note_label: 'Opmerking (optioneel)',
    note_placeholder: 'Voeg een optionele opmerking toe voor deze statuswijziging',
    tech_issue_checkbox: 'Er is een technisch probleem',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  released: {
    yes: 'Ja',
    no: 'Nee',
  },
  configured_status: {
    true: 'Ja',
    false: 'Nee',
  },
  delete_confirmation: {
    title: 'Mobiele app verwijderen',
    message: 'Weet u zeker dat u deze mobiele app wilt verwijderen?',
    buttons: {
      confirm: 'Bevestigen',
      cancel: 'Annuleren',
    },
  },
};
